var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"control-section dashboard-api",attrs:{"id":"dashboard-control-section"}},[_c('div',{staticClass:"content-wrapper",staticStyle:{"max-width":"100%"}},[_c('SPanel',{ref:"sPanel"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }